import React, { useCallback, useEffect, useMemo, useState } from 'react'
import TransaksiService from '../../services/transaksi/TransaksiService'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap'
import Card from '../../components/Card'
import DataTable from 'react-data-table-component'
import ExpandableComponentPnbpReadyBilling from './expand/ExpandableComponentPnbpReadyBilling'
import UPT from '../../utilities/UPT'
import { FaMinus, FaPlus } from 'react-icons/fa'
import SweetAlert from 'react-bootstrap-sweetalert'
import ModalAddBilling from './modal/ModalAddBilling'

const DaftarPnbp = () => {
    const columns = [
        {
            name: 'Nomor Aju',
            cell: row => row['nomorAju']
        },
        {
            name: 'UPT',
            cell: row => <UPT id={row['kodeUpt']} />
        },
        {
            name: 'Nomor PNBP',
            cell: row => row['noPnbp']
        },
        {
            name: 'Tanggal PNBP',
            cell: row => row['tglPnbp']
        },
        {
            name: 'NPWP',
            cell: row => row['npwpTrader']
        },
        {
            name: 'Nama Wajib Bayar',
            cell: row => row['namaTrader']
        },
        {
            name: 'Jenis Dokumen',
            cell: row => row['jnsDok']
        },
        // {
        //     name: "Action",
        //     cell: (row) => (
        //         <>
        //             <div className="row">
        //                 <div className="col-12 mb-1">
        //                     <Button size='sm' variant='info' onClick={() => handleExpandClick(row)}>
        //                         {expandedRows[row.id] ? <><FaEyeSlash/>{' '}Tutup</> : <><FaEye />{' '}Detail</>}
        //                     </Button>
        //                 </div>
        //             </div>

        //         </>
        //     ),
        //     ignoreRowClick: true,
        //     allowOverflow: true,
        //     button: true,
        //     grow: 0
        // },
    ]

    const [expandedRows, setExpandedRows] = useState({});

    const handleExpandClick = (row) => {
        setExpandedRows((prev) => ({
            ...prev,
            [row.id]: !prev[row.id],
        }));
    };

    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const [valueSearchNamaTrader, setValueNamaTrader] = useState(null)
    const onChangeSearchNamaTrader = e => {
        setValueNamaTrader(e.target.value)
    }

    const handleClickReset = () => {
        setValueNamaTrader('')
        getListData(0, 10, null, null)
    }

    const handleClickCari = () => {
        getListData(0, 10, null, valueSearchNamaTrader)
    }

    const getListData = useCallback(async (page, size, kodeUpt = null, namaTrader = null) => {
        setLoading(true)
        try {
            let response
            if (localStorage.getItem("role") === '1') {
                response = await transaksiService.listPnbpReadyBilling(kodeUpt, namaTrader, page, size)
            } else {
                response = await transaksiService.listPnbpReadyBilling(localStorage.getItem("kdUnit"), namaTrader, page, size)
            }
            setListData(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            setListData([])
        }
        setLoading(false)
    }, [transaksiService])

    useEffect(() => {
        getListData(0, 10)
    }, [getListData])

    const handleChangePage = (page) => {
        getListData(page - 1, size, null, valueSearchNamaTrader)
    }

    const handlePerRowsChange = async (size, page) => {
        let response
        if (localStorage.getItem("role") === '1') {
            response = await transaksiService.listPnbpReadyBilling(null, valueSearchNamaTrader, page - 1, size)
        } else {
            response = await transaksiService.listPnbpReadyBilling(localStorage.getItem("kdUnit"), valueSearchNamaTrader, page - 1, size)
        }
        setListData(response.data.data)
        setSize(size)
    }

    function allSameNpwpFast(data) {
        if (!Array.isArray(data) || data.length === 0) return false;

        const firstNpwp = data[0].npwpTrader;

        for (let i = 1; i < data.length; i++) {
            if (data[i].npwpTrader !== firstNpwp) {
                return false; // langsung keluar
            }
        }
        return true;
    }

    const [showAlert, setShowAlert] = useState(false)
    const handleCloseShowAlert = () => setShowAlert(false)
    const [alertMessage, setAlertMessage] = useState('')
    const [showAddBilling, setShowAddBilling] = useState(false)
    const handleCloseShowAddBilling = () => setShowAddBilling(false)
    const [dataPnbp, setDataPnbp] = useState(null)

    const BuatBilling = () => {
        if (selectedRows.length > 0) {
            let isNpwpSama = allSameNpwpFast(selectedRows)
            if (!isNpwpSama) {
                setAlertMessage('Nama Wajib Bayar Tidak Boleh Berbeda')
                setShowAlert(true)
            } else {
                setDataPnbp(selectedRows)
                setShowAddBilling(true)
            }
        } else {
            setAlertMessage('Silakan Pilih PNBP Terlebih Dahulu')
            setShowAlert(true)
        }
    }

    const [selectedRows, setSelectedRows] = useState([])
    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows)
    }, [])

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Wajib Bayar</Form.Label>
                                            <Col sm="8">
                                                <Form.Control type="searchWajibBayar" placeholder="Nama Wajib Bayar" className="form-control-sm" value={valueSearchNamaTrader} onChange={onChangeSearchNamaTrader} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => handleClickCari()}>Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => handleClickReset()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar PNBP</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <Button type="button" variant="primary" size="sm" onClick={() => BuatBilling()}><FaPlus /> Buat Billing</Button>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listData}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                    selectableRows
                                    onSelectedRowsChange={handleRowSelected}
                                    expandableRows
                                    expandableRowsComponent={({ data }) => <ExpandableComponentPnbpReadyBilling data={data} />}
                                    expandOnRowDoubleClicked
                                    expandableIcon={{
                                        collapsed: <FaPlus size={12} color="blue" />, // Custom expand icon
                                        expanded: <FaMinus size={12} color="red" />,   // Custom collapse icon
                                    }}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ModalAddBilling showAddBilling={showAddBilling} handleCloseShowAddBilling={handleCloseShowAddBilling} dataPnbp={dataPnbp} reloadList={getListData} />
            {
                showAlert &&
                <SweetAlert
                    title="Gagal"
                    danger
                    onConfirm={handleCloseShowAlert}
                    btnSize="sm"
                >{alertMessage}</SweetAlert>
            }
        </>
    )
}

export default DaftarPnbp